/**
 * Tabs Component - Constants
 * ============================
 * Tabs de navegación por subrayado (Figma: node 656:1005, "Tabs"). Value-based
 * leaf (mismo tipo de puente ngModel que radio/chips/segmented-control — ver
 * PASO 0 de `templates/leaf-component.md`): un solo componente que renderiza
 * sus opciones desde el binding `options` (array, mismo criterio que
 * SegmentedControl/Select), no un compound con hijos.
 *
 * Figma especifica un único tratamiento visual (sin variantes de tamaño ni
 * fondo, a diferencia de SegmentedControl) — por eso no hay mapa de SIZES ni
 * un `DEFAULTS` que configurar.
 */

// ============================================================================
// TYPES
// ============================================================================

export interface TabsOption {
  value: string;
  label: string;
}

// ============================================================================
// BASE
// ============================================================================

export const BASE_CLASSES = {
  container: 'ec-inline-flex ec-items-center ec-gap-px ec-font-main',
  // border-b-4 SIEMPRE presente (transparente si no está seleccionada) para
  // que el alto del tab activo no varíe respecto a sus vecinos al alternar
  // selección — el Figma solo muestra el borde en el tab activo, pero
  // reservar el espacio evita el salto de layout.
  option:
    'ec-flex ec-flex-col ec-items-start ec-p-3 ec-border-0 ec-border-b-4 ec-border-solid ' +
    'ec-text-sm ec-tracking-[-0.42px] ec-text-left ec-whitespace-nowrap ' +
    'ec-cursor-pointer ec-bg-transparent ec-transition-colors ' +
    'focus-visible:ec-outline-none focus-visible:ec-ring-2 focus-visible:ec-ring-color-primary focus-visible:ec-ring-offset-1',
  // Figma "small" (regular) + texto secundario (#4D4D4D = color-text-secondary).
  unselected: 'ec-border-transparent ec-font-normal ec-text-color-text-secondary',
  // Figma "small semibold" + subrayado/texto primary (#1744D4 = color-primary).
  selected: 'ec-border-color-primary ec-font-semibold ec-text-color-primary'
};
